/**
 * ErrorAlert Component
 * 
 * CloudScape-based error alert for displaying validation errors,
 * authentication failures, and other error states.
 */

import { Alert } from '@cloudscape-design/components';
import React from 'react';

export interface ErrorAlertProps {
  message: string | string[];
  onDismiss?: () => void;
}

export const ErrorAlert: React.FC<ErrorAlertProps> = ({ message, onDismiss }) => {
  const messages = Array.isArray(message) ? message : [message];
  
  if (messages.length === 0 || (messages.length === 1 && !messages[0])) {
    return null;
  }

  return (
    <Alert
      type="error"
      dismissible={!!onDismiss}
      onDismiss={onDismiss}
    >
      {messages.length === 1 ? (
        messages[0]
      ) : (
        <ul style={{ margin: 0, paddingLeft: '20px' }}>
          {messages.map((msg, index) => (
            <li key={index}>{msg}</li>
          ))}
        </ul>
      )}
    </Alert>
  );
};
